
class PrintController {
  /*@ngInject*/
  constructor(Auth, $state, $scope, User, UserService, DateUtil, $translate, ShipmentService, BagoutService, Modal, $location, RouteService, LocationService, SetupService, BranchService, Branch, Sound, $q) {

    this.$state = $state
    this.$scope = $scope;
    this.User = User
    this.$translate = $translate
    this.BagoutService = BagoutService
    this.RouteService = RouteService
    this.LocationService = LocationService
    this.BranchService = BranchService
    this.Branch = Branch;
    this.SetupService = SetupService;
    this.$q = $q;
    this.Sound = Sound;
    this.Modal = Modal
    this.$location = $location
    this.ShipmentService = ShipmentService
    this.DateUtil = DateUtil
    this.todayDate = moment().hour(0).minutes(0).seconds(0).toDate();
    this.routes = [];
    this.holdRoute = '';
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();
    this.model = {
      bagout: {
        id: '',
        gettingRoutes: false
      },
      deliveryDate: '',
      branchId: this.User.getUser().branchId,
      supervisorId: this.User.getUser() .id,
      isSupervisor: _.isUndefined(this.User.getUser().supervisor) ? false : this.User.getUser().supervisor
    }
    this.isBagoutSelected = false;
    this.bagOutData = "";
    this.branchFromLocation = {};

    this.barcodeOptions =
    {
        format: 'CODE128', lineColor: '#030303', width: 3.7, height: 100, displayValue: false,
        font: 'monospace', textAlign: 'center', textPosition: 'bottom', textMargin: 0, fontSize: 25,
        marginTop: 0, marginBottom: 0
    }
  }

  $onInit() {
    this.focusElementById('bagout-scan-id');
    const bagoutId = this.$location.search().bagout;
    var self = this;
    this.BranchService.getBranchSetup(this.model.branchId)
      .then((data) => {
        this.supervisorScan = data.supervisorScan;
        if (data.holdRouteId) {
          this.RouteService.get(data.holdRouteId)
            .then((route) => {
              if (route && route.id) {
                this.holdRoute = route;
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                this.Modal.errorModal(err.data.message)
                // console.log(err);
              }
            })
        }
      });

    this.SetupService.get(this.model.branchId)
      .then((data) => {
        this.model.deliveryDate = this.DateUtil.convertToDate(data.currentVaultDate)
        this.vaultDate = this.DateUtil.convertToDate(data.currentVaultDate)
        this.finalVaultDate = {
          minDate: this.vaultDate
        }
        this.branchFromLocation = data.fromLocation;
      })
      .catch((err) => {
        console.log(err);
      })

    if (bagoutId) {
      this.model.bagout.id = bagoutId;
      this.Branch.getBranchDetails(this.model.branchId)
        .then(function (branchDetails) {
          self.prefixes = branchDetails.prefixes;
          self.bagoutScanned()
        });
    }

  }

  focusElementById(id) {
    setTimeout(() => {
      document.getElementById(id).focus();
    }, 300);
  }

  bagoutScanned() {
    var finalBagoutData;
    if (this.model.bagout.id === "" || this.model.bagout.id == undefined) {
      return;
    }

    finalBagoutData = this.model.bagout.id;
    this.isLoading = false;
    return this.BagoutService.getShipments(finalBagoutData)
      .then((res) => {
        this.bagSealId = res.data.bagout.id;
        this.model.isError = false;
        this.model.bagout = Object.assign({}, res.data.bagout, {
          shipments: res.data.shipments,
          totalBags: res.data.shipments.length,
          totalAmount: res.data.shipments.reduce((partialTotal, shipment) => partialTotal + shipment.amount, 0)
        });
        this.isBagoutSelected = true;
        this.Sound.playSuccessBeep("#success_beep");
        return this.loadVisitingRoutes();
      })
      .catch((err) => {
        this.model.isError = true;
        if (err && err.data && err.data.message) {
          this.model.bagout.id = "";
          finalBagoutData = "";
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.model.message = this.$translate.instant(err.data.message);
        }
        else {
          this.model.message = this.$translate.instant(error.UnableToLocateBagout);
        }
        // this.model.message = "";
        this.isBagoutSelected = false
      });
  }

  _closeBagout(modal) {
    const bagoutDetails = this.model.bagout;
    const shipmentData = [];
    const shipments = bagoutDetails.shipments;

    shipments.forEach((s) => {
      shipmentData.push({
        trackingId: s.trackingId,
        amount: s.amount,
        denominationId: s.denominationId,
        locationId: s.fromLocation.id,
        locationName: s.fromLocation.name,
        stopProcess:  s.fromLocation.stopProcess
      })
    })

    return this.BagoutService.closeBagout(
      bagoutDetails.id,
      this.model.branchId,
      this.model.route.id,
      moment(this.model.deliveryDate).format('YYYY-MM-DD'),
      bagoutDetails.carrierId ? bagoutDetails.carrier.id : null,
      bagoutDetails.carrierId ? bagoutDetails.carrier.name : null,
      this.model.supervisorId,
      shipmentData
    )
  }

  closeBagout(isPrint) {
    // console.log(this.supervisorScan , this.model.isSupervisor)
    if (!isPrint && this.isLoading) {
      return;
    } else {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500)
    }

    if (this.supervisorScan || !this.model.isSupervisor) {
      this.Modal.confirmSupervisor('verify-hold', null, ({ modal, supId }) => {
        this.putOnHold(true, isPrint, modal, supId);
      }, ({ modal }) => {
        this.isLoading = false;
        modal.close();
      })
    } else {
      this.Modal.confirm({
        header: this.$translate.instant('bagout.confirmCloseBagoutTitle'),
        message: this.$translate.instant('bagout.confirmCloseBagoutMessage') + ` <strong>${this.model.bagout.id}</strong>?`,
        callback: ({
          modal,
          $scope
        }) => {
          if (this.model.route.id == this.holdRoute.id) {
            modal.close();
            $scope.isLoading = true;
            this.putOnHold(true, isPrint, modal, this.model.supervisorId)
          } else {
            $scope.loading = true;
            this._closeBagout(modal, $scope)
              .then((res) => {
                if (res.data && res.data.closed) {
                  modal.close();
                  this.isLoading = true;
                  if (isPrint) {
                    this.isLoading = false;
                    return this.print();
                  }
                }
              }).catch((err) => {
                modal.close();
                if (err && err.data && err.data.message) {
                  this.Sound.PlayErrorBeep("#scanner_beep");
                  const error = err.data.message.length > 7 ? err.data.message : 'error.' + err.data.message;
                  this.Modal.errorModal(error)
                }
              })
              .finally(() => {
                this.bagoutScanned();
              })
          }
        },
        type: 'danger'
      })
    }
  }

  deleteBagout(){
    this.Modal.confirm({
      header: this.$translate.instant('bagout.confirmDeleteBagoutTitle'),
      message: this.$translate.instant('bagout.confirmDeleteBagoutMessage') + ` <strong>${this.model.bagout.id}</strong>?`,
      callback: ({
        modal,
        $scope
      }) => {
          this.BagoutService.deleteBagout(this.model.bagout.id).then((response) => {
            this.isLoading = true;
            if(res.status) {
              this.Sound.playSuccessBeep("#success_beep");
              modal.close();
            }
          }).catch((err) => {
                modal.close();
                if (err && err.data && err.data.message) {
                  this.Sound.PlayErrorBeep("#scanner_beep");
                  const error = err.data.message.length > 7 ? err.data.message : 'error.' + err.data.message;
                  this.Modal.errorModal(error)
                }
              }).finally(() => {
                    this.isLoading = true;
                    this.goToBagout();
              })
      },
      type: 'danger'
    })
  }

  
  // put shipment on hold if route id same as hold route
  confirmSupervisor(closeBagout, isPrint) {
    this.Modal.confirmSupervisor('verify-hold', null, ({ modal, supId }) => {
       return this.putOnHold(closeBagout, isPrint, modal, supId);
    }, ({ modal }) => {
      this.isPutOnHold = false;
      this.isLoading = false;
      modal.close();
    });
  }

  putOnHold(closeBagout, isPrint, modal=null, supId=null) {
    let allPromise = [];
    this.isPutOnHold = true;
    if (closeBagout) {
      allPromise.push(this._closeBagout());
    }
    this.$q.all(allPromise)
    .then((data) => {
        this.ShipmentService.holdShipment(
          this.model.branchId,
          this.model.bagout.id,
          this.model.route.id,
          moment(this.vaultDate).format('YYYY-MM-DD'),
          supId,
          '',
          ''
        ).then((data) => {
          modal.close();
          if (isPrint) {
            return this.print();
          }
        })
          .catch((err) => {
            modal.close();
            if (err && err.data && err.data.message) {
              this.Modal.errorModal('error.' + err.data.message)
            }
          })
          .finally(() => {
            this.isPutOnHold = false;
            this.bagoutScanned();
          });
      })
      .catch((err) => {
        this.isPutOnHold = false;
        if (err && err.data && err.data.message) {
          if (modal) modal.close();
          this.Sound.PlayErrorBeep("#scanner_beep");
          const error = err.data.message.length > 7 ? err.data.message : 'error.' + err.data.message;
          return this.Modal.errorModal(error);
        }
      });
  }

  loadVisitingRoutes() {
    if (!this.model.bagout || !this.model.bagout.location || !this.model.bagout.location.id) {
      return;
    }

    const dayIndex = moment(this.model.deliveryDate).day();
    const weekDays = [
      'Sun',
      'Mon',
      'Tue',
      'Wed',
      'Thu',
      'Fri',
      'Sat'
    ];

    this.model.gettingRoutes = true;
    this.$q.all([
      this.LocationService.getVisitingRoutes(this.model.bagout.location.id, weekDays[dayIndex]), // for selected index
      this.BagoutService.getDeliveryRoutes(this.model.branchId, moment(this.model.deliveryDate).format('YYYY-MM-DD')) // fro route list
    ])
      .then((data) => {
        this.routes = data[1].results ? data[1].results.slice() : [];

        if (this.holdRoute) {
          this.routes.push(this.holdRoute);
        }

        if (data[0].results) {
          if (data[0].results.length === 0 && this.holdRoute) {
            this.model.route = this.routes[_.findIndex(_this5.routes, { id: _this5.holdRoute.id })];;
          }
          else if (data[0].results.length === 1) {
            let selectedIndex = _.findIndex(this.routes, { id: data[0].results[0].id });
            this.model.route = selectedIndex >= 0 ?
              this.routes[selectedIndex] :
              this.routes[_.findIndex(this.routes, { id: this.holdRoute.id })];
          }
        }
        else if (this.holdRoute) {
          this.model.route = this.routes[_.findIndex(this.routes, { id: this.holdRoute.id })];;
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.model.gettingRoutes = false;
      })
  }

  print() {
    setTimeout(() => {
      window.print();
    }, 1000)
    this._clearTimeOut();
  }

  _clearTimeOut() {
    let timeId = setTimeout(() => {
      this.isLoading = false;
      this.isBagoutSelected = true;
      this.isPutOnHold = false;
      this.$scope.$apply();
      clearTimeout(timeId);
    }, 1000);
  }

  confirmPrint() {
    if (this.isLoading) return;
    this.isLoading = true;

    if (!this.model.bagout.closed) {
      this.closeBagout(true)
    }
    else {
      this.print();
    }
    this._clearTimeOut();
  }

  goToBagout() {
    window.history.go(-1)
  }

  dateChanged() {
    this.loadVisitingRoutes();
  }
}

export default PrintController;


// WEBPACK FOOTER //
// ./client/app/components/bagout/print/print.controller.js